import { all, put, takeLeading } from 'redux-saga/effects'

import ApiSagas from '../api/sagas'
import { actions } from '../index'
import SendMessage from '../../rest/requests/messages/sendMessage'

export default class MailSagas {
  static *onSendContactMail({
    payload,
  }: ReturnType<typeof actions.mail.sendMessageRequest>) {
    const response = yield* ApiSagas.rest(SendMessage(payload))

    // console.log('src/redux/mail/sagas.ts', payload, response)

    if (response.data || response.status === 200) {
      yield put(actions.mail.sendMessageSuccess(response.data))
    } else {
      yield put(actions.mail.sendMessageError(response.errors))
    }
  }

  static *loop() {
    yield all([
      takeLeading(actions.mail.sendMessageRequest, this.onSendContactMail),
    ])
  }
}
